import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footerfr',
    templateUrl: './footerfr.component.html',
    styleUrls: ['./footerfr.component.scss'],
    standalone: false
})
export class FooterfrComponent implements OnInit {
  public currentDate: Date;
  public currentYear: number;
   constructor() { }
 
   ngOnInit() {  
      // Get the current date
      this.currentDate = new Date(); 
 
     // Extract the year from the date
     this.currentYear = this.currentDate.getFullYear();
   }

}
